<template>
  <div
    class="rounded-lg h-full overflow-hidden flex flex-col"
    style="box-shadow: 2px 2px 14px 0px #E5EDF4;"
  >
    <figure class="relative flex flex-shrink-0 pt-5/9 items-end justify-center">
      <picture class="absolute inset-0">
        <img v-bind:src="article.thumb || noImage" class="w-full h-full object-cover object-top rounded-lg" />
      </picture>
    </figure>
    <!-- Тело карточки -->
    <div class="flex flex-col justify-between pt-4 px-4 pb-6 gap-3 flex-grow">
      <div class="flex flex-col gap-3">
        <p class="h-12 two-line-ellipsis text-primary font-semibold text-20/24">
          {{ article.title }}
        </p>
        <!-- Полоска со статистикой -->
        <div class="flex flex-row items-end text-gray-800 gap-2.5 h-5 text-12/16 leading-none">
          <div class="flex flex-row gap-1.5 items-center">
            <img v-bind:src="calendarIcon"/>
            <span>{{ article.published_at }}</span>
          </div>
          <div class="flex flex-row gap-1.5 items-center">
            <img v-bind:src="eyeIcon"/>
            <span>{{ article.view_count }}</span>
          </div>
          <!-- Оценка пока не реализована
          <div class="flex flex-row gap-1.5 items-center">
            <img v-bind:src="starIcon"/>
            <span>5</span>
          </div>
          -->
        </div>
        <!-- Теги -->
        <div v-if="article.tags.length > 0" class="flex gap-2.5 text-12/16 flex-wrap">
          <div v-for="tag in filteredTags"
               :key="tag"
               class="rounded-lg px-2 py-1.5 leading-none w-min cursor-default"
               :class="selectedTags.includes(tag.id) ? 'bg-purple-150' : 'bg-secondary-lightest'"
          >
            #{{ tag.name }}
          </div>
        </div>
        <p class="four-line-ellipsis">
          {{ article.preview }}
        </p>
      </div>
      <a v-bind:href="article.link" class="button-md button-primary px-8">Читать</a>
    </div>
  </div>
</template>

<script>
import calendarIcon from "calendar.svg";
import eyeIcon from "eye.svg";
import starIcon from "rounded-five-point-star.svg";
import noImage from "noimage.png";

export default {
  props: {
    article: {
      type: [Object],
      default: {}
    },
    // Если карточка показывается на странице с поиском по тегам
    selectedTags: {
      type: [Array],
      default: []
    }
  },
  data() {
    return {
      calendarIcon,
      eyeIcon,
      starIcon,
      noImage
    }
  },
  computed: {
    // В карточке показываются 2 из макс. 5 тегов статьи, приоритет у выбранных
    filteredTags() {
      if (this.selectedTags.length > 0) {
        return [...this.article.tags].sort((tag1, _tag2) => {
          if (this.selectedTags.includes(tag1.id)) return -1
          else return 1
        }).slice(0, 2)
      } else {
        return this.article.tags.slice(0, 2)
      }
    }
  }
}
</script>

<style>
.two-line-ellipsis {
  overflow: hidden;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.four-line-ellipsis {
  overflow: hidden;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
</style>